export const MESSAGE_CODE = {
  등록: "등록이 완료 되었습니다.",
  수정: "수정이 완료 되었습니다.",
  삭제: "삭제가 완료 되었습니다.",
  저장: "저장이 완료 되었습니다.",
  실패: "실패하였습니다. 잠시 후 다시 시도해주세요.",
};
